import { StationAvatar } from '@app/components/base/stations/StationAvatar';
import { Station } from '@app/core/types/stations';
import { Chip } from '@mui/material';

type Props = {
  station: Station;
};

/**
 * Read-only chip for a station linked to the selected connection.
 */
export function ConnectionStationChip({ station }: Props) {
  return (
    <Chip
      label={station.name}
      avatar={<StationAvatar stationId={station.id} station={station} size={24} />}
      variant="outlined"
    />
  );
}
